import { render } from "./EmployeeDataImportModal.vue?vue&type=template&id=ae2ef198&scoped=true"
import script from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"

import "./EmployeeDataImportModal.vue?vue&type=style&index=0&id=ae2ef198&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2ef198"]])

export default __exports__